module.exports = __webpack_public_path__ + "static/media/noun-tv-4765847-142350.87a7c12c.svg";